<div class="flex justify-center w-full pb-[80px]" >
    <div class="grid grid-cols-3 gap-[25px] max-mobile:grid-cols-1 max-laptop:grid-cols-2">
         {#each items as item}
            <ItemData item={item}></ItemData>
        {/each}
    </div>
</div>
<script lang="ts">
    import ItemData from './Item.svelte'
    import type { DialogPickerItem } from "$lib/types/dialog";
    import type { Optional } from "$lib/types/generic";
    export let items: Optional<DialogPickerItem[]> = undefined;
</script>